import { Auth, API } from 'aws-amplify';
import { getAppVersion } from '../../utils/helpers';
import * as type from './types';
import { ssoCreds, obeeSso } from '../graphql/queries';
import { devLog } from '../../utils';

export const setUserAction = (user) => (dispatch) => {
  dispatch({
    type: type.FETCH_USER_SUCCESS,
    payload: user,
  });
};

export const fetchUserAction = (userId, userType) => (dispatch) => {
  dispatch({
    type: type.SET_ID_APP_LOADING,
    payload: 'FETCH_USER',
  });
  dispatch({
    type: type.FETCH_USER_PENDING,
  });

  const getData = async () => {
    try {
      // Simulating a successful login
      dispatch({
        type: type.FETCH_USER_SUCCESS,
        payload: { id: userId, restaurants: [], userType },
      });
    } catch (error) {
      devLog('error', 'fetch user', error);
      dispatch({
        type: type.FETCH_USER_FAILURE,
        payload: error.errors[0].message,
      });
    } finally {
      dispatch({
        type: type.REMOVE_ID_APP_LOADING,
        payload: 'FETCH_USER',
      });
    }
  };
  getData();
};

// Obee SSO
export const fetchObeeSsoCredsAction = (ssoToken) => (dispatch) => {
  dispatch({
    type: type.FETCH_SSO_CREDS_PENDING,
  });

  const getData = async () => {
    try {
      const response = await API.graphql(
        {
          query: obeeSso,
          variables: { ssoToken },
        },
        {
          'app-version': getAppVersion(),
          'X-App-Environment': import.meta.env?.VITE_API_ENVIRONMENT,
        },
      ).catch((error) => {
        throw new Error(error.errors[0].message);
      });
      devLog('success', 'sso token', response?.data?.obeeSSO);

      const parsedResponse = JSON.parse(response?.data?.obeeSSO);

      dispatch({
        type: type.FETCH_SSO_CREDS_SUCCESS,
        payload: parsedResponse,
      });
    } catch (error) {
      devLog('error', 'sso creds', error);

      dispatch({
        type: type.ADD_MESSAGE,
        payload: {
          id: `FETCH_SSO_CREDS_${new Date().getTime()}`,
          message: `Error, unable to fetch sso creds.`,
          severity: 'error',
        },
      });

      dispatch({
        type: type.FETCH_SSO_CREDS_FAILURE,
        payload: `Unable to fetch sso creds: ${error}`,
      });
    }
  };
  getData();
};

export const setLogoutAction = (slug) => (dispatch) => {
  devLog('info', 'Logging out', slug, window.location);

  const backRedirectParam = import.meta.env.VITE_REDIRECT_LOGIN_URL
    ? `?redirect_url=${window.location.origin}/obeeLogin`
    : '';

  const redirectUrl = slug
    ? `${import.meta.env.VITE_EXTERNAL_LOGOUT_URL_START}${slug}${import.meta.env.VITE_EXTERNAL_LOGOUT_URL_END}${backRedirectParam}`
    : `${window.location.origin}/obeeLogin`;

  devLog('info', `redirect URL is ${redirectUrl}`);

  dispatch({
    type: type.SET_LOGOUT_PENDING,
    payload: redirectUrl,
  });

  Auth.signOut()
    .then((data) => {
      devLog('success', 'signed out', data);

      dispatch({
        type: type.SET_LOGOUT,
        payload: redirectUrl,
      });
    })
    .catch((error) => {
      devLog('error', 'signed out', error);
    });
};

export const clearLoginErrorAction = () => (dispatch) => {
  dispatch({
    type: type.CLEAR_LOGIN_ERROR,
  });
};

export const fetchSsoCredsAction = (ssoToken) => (dispatch) => {
  dispatch({
    type: type.FETCH_SSO_CREDS_PENDING,
  });

  const getData = async () => {
    try {
      const response = await API.graphql(
        {
          query: ssoCreds,
          variables: { ssoToken },
        },
        {
          'app-version': getAppVersion(),
          'X-App-Environment': import.meta.env?.VITE_API_ENVIRONMENT,
        },
      ).catch((error) => {
        throw new Error(error.errors[0].message);
      });
      devLog('success', 'sso token', response?.data?.ssoCreds);

      const parsedResponse = JSON.parse(response?.data?.ssoCreds);

      dispatch({
        type: type.FETCH_SSO_CREDS_SUCCESS,
        payload: parsedResponse?.ssoCreds,
      });
    } catch (error) {
      devLog('error', 'sso creds', error);

      dispatch({
        type: type.ADD_MESSAGE,
        payload: {
          id: `FETCH_SSO_CREDS_${new Date().getTime()}`,
          message: `Error, unable to fetch sso creds.`,
          severity: 'error',
        },
      });

      dispatch({
        type: type.FETCH_SSO_CREDS_FAILURE,
        payload: `Unable to fetch sso creds: ${error}`,
      });
    }
  };
  getData();
};
